export interface MenuItem {
  title: string;
  userRole: string[];
  rootUrl?: string;
  routerLink?: string;
  children?: MenuItem[];
  tooltip?: string;
}

export const sideNavItems: MenuItem[] = [
  {
    title: 'MENU.HOME',
    userRole: [],
    routerLink: '/home',
  },
  {
    title: 'MENU.ACQUISITION',
    userRole: [],
    rootUrl: 'buying',
    children: [
      {
        title: 'MENU.MARKET',
        userRole: [],
        routerLink: '/buying/search',
      },
      {
        title: 'MENU.PURCHASES_OUTGOING',
        userRole: [],
        routerLink: '/buying/purchase-lists',
      },
      // Így fog kinézni, amikor lesz "Rendelési listák" menü is:
      // {
      //   title: 'MENU.MY_ORDERS',
      //   userRole: [],
      //   rootUrl: 'buying/orders/purchase-lists',
      //   children: [
      //     {
      //       title: 'MENU.ORDER_LISTS',
      //       userRole: [],
      //       routerLink: '/buying/orders/order-lists',
      //     },
      //     {
      //       title: 'MENU.PURCHASES_OUTGOING',
      //       userRole: [],
      //       routerLink: '/buying/orders/purchase-lists',
      //     },
      //   ],
      // },
      {
        title: 'MENU.SORTIMENT',
        userRole: [],
        routerLink: '/buying/sortiment/product-sortiment',
      },
      {
        title: 'MENU.DISCOUNTS',
        userRole: [],
        rootUrl: 'buying/vip-discounts',
        children: [
          {
            title: 'MENU.VIP_DISCOUNTS_RECEIVED',
            userRole: [],
            routerLink: '/buying/vip-discounts',
          },
        ],
      },
    ],
  },
  {
    title: 'MENU.SELLING',
    userRole: [],
    rootUrl: 'selling',
    children: [
      {
        title: 'MENU.PURCHASES_INCOMING',
        userRole: [],
        routerLink: '/selling/purchase-lists/in-progress',
      },
      {
        title: 'MENU.SORTIMENT',
        userRole: [],
        routerLink: '/selling/sortiment/product-sortiment',
      },
      {
        title: 'MENU.PRICES',
        userRole: [],
        rootUrl: 'selling/prices',
        children: [
          {
            title: 'MENU.PRICING',
            userRole: ['PRODUCT_ADMIN', 'PRICING_ADMIN'],
            routerLink: '/selling/prices/pricing',
          },
          {
            title: 'MENU.DISCOUNTS',
            userRole: [],
            rootUrl: 'selling/prices/discounts',
            children: [
              {
                title: 'MENU.VIP_DISCOUNTS',
                userRole: [],
                routerLink:
                  '/selling/prices/discounts/vip-discounts/products-and-partners',
              },
              {
                title: 'MENU.QUANTITY_DISCOUNTS',
                userRole: [],
                routerLink:
                  '/selling/prices/discounts/quantity-discounts/products',
              },
              {
                title: 'MENU.SEGMENT_DISCOUNTS',
                userRole: [],
                routerLink: '/selling/prices/discounts/segment-discounts',
              },
              {
                title: 'MENU.BASKET_DISCOUNTS',
                userRole: [],
                routerLink: '/selling/prices/discounts/basket-discounts',
              },
            ],
          },
        ],
      },
      {
        title: 'MENU.DELIVERY',
        userRole: [],
        routerLink: '/selling/delivery-mode',
      },
    ],
  },
  {
    title: 'MENU.SELLING',
    userRole: [],
    rootUrl: 'selling',
    children: [
      {
        title: 'MENU.PURCHASES_INCOMING',
        userRole: [],
        routerLink: '/selling/purchase-lists/in-progress',
      },
      {
        title: 'MENU.SORTIMENT',
        userRole: [],
        routerLink: '/selling/sortiment/product-sortiment',
      },
      {
        title: 'MENU.PRICES',
        userRole: [],
        rootUrl: 'selling/prices',
        children: [
          {
            title: 'MENU.PRICING',
            userRole: ['PRODUCT_ADMIN', 'PRICING_ADMIN'],
            routerLink: '/selling/prices/pricing',
          },
          {
            title: 'MENU.DISCOUNTS',
            userRole: [],
            rootUrl: 'selling/prices/discounts',
            children: [
              {
                title: 'MENU.VIP_DISCOUNTS',
                userRole: [],
                routerLink:
                  '/selling/prices/discounts/vip-discounts/products-and-partners',
              },
              {
                title: 'MENU.QUANTITY_DISCOUNTS',
                userRole: [],
                routerLink:
                  '/selling/prices/discounts/quantity-discounts/products',
              },
              {
                title: 'MENU.SEGMENT_DISCOUNTS',
                userRole: [],
                routerLink: '/selling/prices/discounts/segment-discounts',
              },
              {
                title: 'MENU.BASKET_DISCOUNTS',
                userRole: [],
                routerLink: '/selling/prices/discounts/basket-discounts',
              },
            ],
          },
        ],
      },
      {
        title: 'MENU.TENDERS',
        userRole: [],
        routerLink: '/selling/tenders',
      },
      {
        title: 'MENU.DELIVERY',
        userRole: [],
        routerLink: '/selling/delivery-mode',
      },
    ],
  },
  {
    title: 'MENU.ACCOUNT',
    userRole: [],
    rootUrl: 'account',
    children: [
      {
        title: 'MENU.MERCHANT_BASIC_DATA',
        userRole: [],
        routerLink: '/account/merchant',
      },
      // Így fog kinézni, amikor lesz másik menüpont is a "Cég adatlap" mellett:
      // {
      //   title: 'MENU.MERCHANT_DATA',
      //   userRole: [],
      //   rootUrl: 'account/merchant',
      //   children: [
      //     {
      //       title: 'MENU.MERCHANT_BASIC_DATA',
      //       userRole: [],
      //       routerLink: '/account/merchant',
      //     },
      //   ],
      // },
      {
        title: 'MENU.USERS',
        userRole: [],
        routerLink: '/account/users',
      },
    ],
  },
];

export const sideNavAdminItems: MenuItem[] = [
  {
    title: 'MENU.ADMIN.PRODUCTS.TITLE',
    userRole: ['EASYLOT_ADMIN'],
    rootUrl: 'admin/products',
    children: [
      {
        title: 'MENU.ADMIN.PRODUCTS.PRODUCTS',
        userRole: ['EASYLOT_ADMIN'],
        routerLink: '/admin/products',
      },
    ],
  },
  {
    title: 'MENU.ADMIN.APPROVALS.TITLE',
    userRole: ['EASYLOT_ADMIN'],
    rootUrl: 'admin/approvals',
    children: [
      {
        title: 'MENU.ADMIN.APPROVALS.MERCHANTS',
        userRole: ['EASYLOT_ADMIN'],
        routerLink: '/admin/approvals/merchants',
      },
      {
        title: 'MENU.ADMIN.APPROVALS.PRODUCTS',
        userRole: ['EASYLOT_ADMIN'],
        routerLink: '/admin/approvals/products',
      },
      {
        title: 'MENU.ADMIN.APPROVALS.CONTAINERS',
        userRole: ['EASYLOT_ADMIN'],
        routerLink: '/admin/approvals/containers',
      },
      {
        title: 'MENU.ADMIN.APPROVALS.PACKAGING',
        userRole: ['EASYLOT_ADMIN'],
        routerLink: '/admin/approvals/packaging',
      },
      {
        title: 'MENU.ADMIN.APPROVALS.TAKE_OVER',
        userRole: ['EASYLOT_ADMIN'],
        routerLink: '/admin/approvals/product-take-over',
      },
    ],
  },
  {
    title: 'HEADER.BTN.ADMIN.STATISTICS',
    userRole: ['EASYLOT_ADMIN'],
    routerLink: '/admin/statistics',
  },
  {
    title: 'MENU.ADMIN.IMPERSONATION',
    userRole: ['EASYLOT_ADMIN', 'IMPERSONATION'],
    routerLink: '/admin/impersonation',
  },
];

export const sideNavTelesalesItems: MenuItem[] = [
  {
    title: 'Telesales.PARTNER_REGISTRATION.TITLE',
    userRole: [],
    routerLink: '/telesales/partner-registration',
  },
];
